



















































































import { Vue, Component } from 'vue-property-decorator';
import AuthenticateApi from '../store/api/AuthenticateApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import { EMPTY_GUID } from '@/config/constants';

@Component({
    components: {
        Snackbar
    }
})
export default class LoginRegister extends Vue {
    bgColor = 'rgb(1,26,65)';
    username = '';
    password = '';
    overlay = false;

    authenticateApi = new AuthenticateApi();

    async login() {
        this.overlay = true;

        try {
            const userId = await this.authenticateApi.login(
                this.username,
                this.password
            );

            const userFromStorage: IAuthentication =
                JSON.parse(sessionStorage.getItem('user') || '{}');

            if (userId) {
                Vue.prototype.$IsLogged = true;

                if (userFromStorage.idPerson !== EMPTY_GUID) {
                    this.$router.push({
                        name: 'Dashboard'
                    }).catch(() => {});
                } else {
                    this.$router.push({
                        name: 'CustomerDashboard'
                    }).catch(() => {});
                }
            } else {
                const errors =
                    this.authenticateApi.getModelError().join('; ');

                (this.$refs.snackbar as Snackbar)
                .showError(errors);
            }
        } catch (error) {
            (this.$refs.snackbar as Snackbar)
            .showError('Unexpected error during login.');

            console.error(error);
        } finally {
            this.overlay = false;
        }
    }
}
